/**
 * Null 도메인 Query Hook Wrapper
 */

import {useQuery} from '@tanstack/react-query';
import {DEV_QUERY_KEY_MAP} from '../api/dev/constant';
import {devFactory} from '../factory/devFactory';

// ============================================
// useSampleErrorQuery
// ============================================

export function useSampleErrorQuery(
  ...args: Parameters<typeof devFactory.sampleError>
) {
  return useQuery(devFactory.sampleError(...args));
}

useSampleErrorQuery.getKey = (
  ...args: Parameters<typeof DEV_QUERY_KEY_MAP.sampleError>
) => [...DEV_QUERY_KEY_MAP.sampleError(...args)];
